import React, { useState } from "react";
import Papa from "papaparse";
import { toast } from "react-hot-toast";
import { getAuth } from "firebase/auth";
import {
  doc,
  setDoc,
  deleteDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { db } from "../utils/firebaseConfig";
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";

export default function SubirCSV() {
  const [subiendo, setSubiendo] = useState(false);
  const version = "20250824";

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const user = getAuth().currentUser;
    if (!user || user.email !== "admin@empresa.com") {
      toast.error("❌ No estás autorizado para subir productos");
      return;
    }

    setSubiendo(true);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        try {
          const nuevosProductosCSV = results.data.filter(
            (row) => row.nombre && row.precio && row.sku
          );

          // 🚨 Leer los productos reales de Firebase
          const snapshot = await getDocs(collection(db, "productos"));
          const mapaActual = new Map();
          snapshot.forEach((docSnap) => {
            const data = docSnap.data();
            mapaActual.set(data.sku, data);
          });

          // 🔄 Actualizar o agregar productos nuevos
          for (let row of nuevosProductosCSV) {
            const productoNuevo = {
              sku: row.sku,
              nombre: row.nombre,
              descripcion: row.descripcion || "",
              imagen: row.imagen ? `${row.imagen}?v=${version}` : "",
              precio: Number(row.precio || 0),
              categoria: (row.categoria || "").toLowerCase().trim(),
              stock: Number(row.stock || 0),
              id: row.sku,
              modoFardo: row.modoFardo?.toLowerCase() === "true", // 🔥 nuevo campo como booleano
            };

            await setDoc(doc(db, "productos", row.sku), productoNuevo);

            mapaActual.set(row.sku, productoNuevo); // mantener actualizado
          }

          // 🧹 Eliminar productos que ya no están en el CSV
          const csvSKUs = nuevosProductosCSV.map((p) => p.sku);
          for (let key of mapaActual.keys()) {
            if (!csvSKUs.includes(key)) {
              await deleteDoc(doc(db, "productos", key));
              mapaActual.delete(key);
            }
          }

          // Guardar localmente solo para vista rápida
          const productosFinales = Array.from(mapaActual.values());
          localStorage.removeItem("productos");
          localStorage.setItem("productos", JSON.stringify(productosFinales));
          try {
            const seoIndex = productosFinales.map(p => ({
              sku: p.sku,
              nombre: p.nombre,
              descripcion: p.descripcion || "",
              categoria: p.categoria || "",
              precio: typeof p.precio === "number" ? p.precio : Number(p.precio || 0),
              imagen: p.imagen || ""
            }));
            const storage = getStorage();
            const idxRef = ref(storage, "seo/products-index.json");
            await uploadString(idxRef, JSON.stringify(seoIndex), "raw", {
              contentType: "application/json",
              cacheControl: "public, max-age=300" // 5 min
            });
            const publicUrl = await getDownloadURL(idxRef);
            console.log("🔗 SEO index publicado:", publicUrl);
          } catch (e) {
            console.warn("No se pudo publicar el índice SEO:", e);
          }

          toast.success(`🎉 ${productosFinales.length} productos actualizados`);
          setTimeout(() => window.location.reload(), 1000);
        } catch (error) {
          console.error("❌ Error al procesar CSV:", error);
          toast.error("Error al procesar el archivo");
        } finally {
          setSubiendo(false);
        }
      },
    });
  };

  return (
    <div className="py-4 flex flex-col items-start space-y-3">
      <label className="text-sm font-medium text-gray-700">
        Subir nuevo catálogo (.csv):
      </label>
      <input
        type="file"
        accept=".csv"
        onChange={handleFile}
        disabled={subiendo}
        className="border border-gray-300 p-2 rounded cursor-pointer bg-white"
      />
      {subiendo && (
        <p className="text-sm text-cyan-600 animate-pulse">
          ⏳ Cargando productos...
        </p>
      )}
    </div>
  );
}
